import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["isValid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { STOCK_TRANSFER_DOMESTIC } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import StockTransferDomesticFormModal from "@/components/stock/StockTransferDomesticFormModal.vue";
export default {
  name: "OderDomesticTransferList",
  components: {
    StockTransferDomesticFormModal: StockTransferDomesticFormModal,
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      editedId: null,
      gettingList: {
        isPending: false,
        cancellationToken: null,
        results: {
          headers: [{
            text: "Reference",
            value: "reference",
            align: "left"
          }, {
            text: "Status",
            value: "status",
            align: "center"
          }, {
            text: "From",
            value: "fromWarehouse",
            align: "left"
          }, {
            text: "To",
            value: "toWarehouse",
            align: "left"
          }, {
            text: "Products",
            value: "nbProductsConcerned",
            align: "center"
          }, {
            text: "",
            value: "actions",
            align: "right",
            cellClass: "text-nowrap",
            sortable: false
          }],
          items: [],
          totalCount: null
        }
      },
      creatingTransfer: {
        isPending: false,
        cancellationToken: null,
        isConfiguring: false,
        form: {
          departureWarehouseIdOfItems: null,
          isImmediateTransfer: false,
          isValid: false
        }
      },
      STOCK_TRANSFER_DOMESTIC: STOCK_TRANSFER_DOMESTIC,
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    departureWarehousesAvailableForNewTransfer: function departureWarehousesAvailableForNewTransfer() {
      var _this2 = this;
      var itemsWithOtherWarehouseDeparture = this.order.items.filter(function (it) {
        var _it$item_provenances;
        return (_it$item_provenances = it.item_provenances) === null || _it$item_provenances === void 0 ? void 0 : _it$item_provenances.some(function (ip) {
          var _ip$stock, _ip$stock2;
          return ((_ip$stock = ip.stock) === null || _ip$stock === void 0 || (_ip$stock = _ip$stock.warehouse) === null || _ip$stock === void 0 ? void 0 : _ip$stock.id_warehouse) > 0 && ((_ip$stock2 = ip.stock) === null || _ip$stock2 === void 0 || (_ip$stock2 = _ip$stock2.warehouse) === null || _ip$stock2 === void 0 ? void 0 : _ip$stock2.id_warehouse) !== _this2.order.id_warehouse;
        });
      });
      var warehousesAvailable = [];
      itemsWithOtherWarehouseDeparture.forEach(function (item) {
        var newWarehouses = item.item_provenances.filter(function (ip) {
          var _ip$stock3, _ip$stock4;
          return ((_ip$stock3 = ip.stock) === null || _ip$stock3 === void 0 || (_ip$stock3 = _ip$stock3.warehouse) === null || _ip$stock3 === void 0 ? void 0 : _ip$stock3.id_warehouse) > 0 && ((_ip$stock4 = ip.stock) === null || _ip$stock4 === void 0 || (_ip$stock4 = _ip$stock4.warehouse) === null || _ip$stock4 === void 0 ? void 0 : _ip$stock4.id_warehouse) !== _this2.order.id_warehouse;
        }).map(function (ip) {
          return ip.stock.warehouse;
        }).filter(function (w) {
          return !warehousesAvailable.map(function (x) {
            return x.id_warehouse;
          }).includes(w.id_warehouse);
        });
        if ((newWarehouses === null || newWarehouses === void 0 ? void 0 : newWarehouses.length) > 0) {
          warehousesAvailable = [].concat(_toConsumableArray(warehousesAvailable), _toConsumableArray(newWarehouses));
        }
      });
      return warehousesAvailable;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.creatingTransfer.isPending;
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this3.search();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    search: function search() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this$gettingList$can, _this4$gettingList$re, _this4$gettingList$re2;
        var _this, data, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.gettingList.isPending = true;
              _this4.gettingList.results.items = [];
              _this4.gettingList.results.totalCount = 0;
              _this = _this4;
              (_this$gettingList$can = _this.gettingList.cancellationTokenSearch) === null || _this$gettingList$can === void 0 || _this$gettingList$can.cancel();
              _this.gettingList.cancellationTokenSearch = axios.CancelToken.source();
              data = {
                forOrderIds: [_this4.order.id_order]
              };
              paramsQuery = Object.encodeToUri(data);
              _context2.next = 10;
              return request("/v1/stock-transfer-domestics?params=".concat(paramsQuery), "get", null, true, "api", null, _this.gettingList.cancellationTokenSearch).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingList.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load list.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 10:
              response = _context2.sent;
              _this4.gettingList.results.items = _toConsumableArray(response.data.value.items);
              _this4.gettingList.results.totalCount = (_this4$gettingList$re = +((_this4$gettingList$re2 = _this4.gettingList.results.items) === null || _this4$gettingList$re2 === void 0 ? void 0 : _this4$gettingList$re2.length)) !== null && _this4$gettingList$re !== void 0 ? _this4$gettingList$re : 0;
              _this4.gettingList.isPending = false;
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    rowClick: function rowClick(item) {
      var _this5 = this;
      if (!item.isBusy) {
        this.editedId = item.id;
        this.$nextTick(function () {
          _this5.$refs.stockTransferDomesticForm.open();
        });
      }
    },
    getStatusClass: function getStatusClass(item) {
      if (item.status === STOCK_TRANSFER_DOMESTIC.STATUS.PENDING.id) return "fill-info";
      if (item.status === STOCK_TRANSFER_DOMESTIC.STATUS.DELIVERED.id) return "fill-success";
      if (item.status === STOCK_TRANSFER_DOMESTIC.STATUS.CANCELLED.id) return "fill-danger";
      return "fill-empty";
    },
    formClosed: function formClosed() {
      this.editedId = null;
    },
    openCreate: function openCreate() {
      this.creatingTransfer.isConfiguring = true;
    },
    cancelCreate: function cancelCreate() {
      this.creatingTransfer.isConfiguring = false;
    },
    create: function create() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$creatingTransfe;
        var _this6$creatingTransf, isValid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.creatingTransfer.isPending = true;
              _this6$creatingTransf = _this6.creatingTransfer.form, isValid = _this6$creatingTransf.isValid, withoutValid = _objectWithoutProperties(_this6$creatingTransf, _excluded);
              _this = _this6;
              (_this$creatingTransfe = _this.creatingTransfer.cancellationToken) === null || _this$creatingTransfe === void 0 || _this$creatingTransfe.cancel();
              _this.creatingTransfer.cancellationToken = axios.CancelToken.source();
              _context3.next = 7;
              return request("/v1/stock-transfer-domestics/orders/".concat(_this6.order.id_order), "post", withoutValid, true, "api", null, _this.creatingTransfer.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to create domestic transfer", true);
                handleErrorData(_this, errorData);
                _this.creatingTransfer.isPending = false;
                throw e;
              });
            case 7:
              _this6.creatingTransfer.isPending = false;
              _this6.creatingTransfer.isConfiguring = false;
              _this6.refresh();
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    stockTransferEntityUpdated: function stockTransferEntityUpdated() {
      this.refresh();
    },
    refresh: function refresh() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.search();
              _this7.$emit("dbChanged");
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    filterVAutocomplete: filterVAutocomplete
  }
};